import React from "react";

const UserportalFooter = () => {
  
  return (
    <>
      <footer className="bg-gray-darkest">
        <div className="container">
          <div className="py-sm-8 py-5">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <h3 className="text-white mb-3 fs-18">İletişim</h3>
                <a
                  href="tel:08503351358"
                  className="d-block text-white text-decoration-none mb-lg-5 mb-4"
                >
                  <i className="fas fa-phone-alt me-3" />
                  0850 335 1358
                </a>
                {/* <a
                  href="mailto:info@jarvis.com"
                  className="d-block text-white text-decoration-none mb-lg-5 mb-4"
                >
                  info@jarvis.com
                </a> */}
              </div>

              <div
                style={{ marginLeft: "auto" }}
                className="col-lg-4 col-md-12"
              >
                <h3 className="text-white mb-3 fs-18">Menü</h3>
                <a
                  href="/login"
                  className="d-block h6 mb-3 text-white text-decoration-none fw-normal"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Giriş Yap</span>
                </a>
                <a
                  href="/login"
                  className="d-block h6 mb-3 text-white text-decoration-none fw-normal"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Kayıt Ol</span>
                </a>
                <a
                  href="https://www.jarvis.com.tr/iletisim"
                  className="d-block h6 mb-3 text-white text-decoration-none fw-normal"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>Bize Ulaşın</span>
                </a>
              </div>

              <div className="col-lg-4 col-md-12">
                <h3 className="text-white mb-3 fs-18">Bizi Takip Edin</h3>
                <div className="h4 mb-0 opacity-50">
                  <a
                    href="https://cargillgurme.com.tr/"
                    target="_blank"
                    className="text-white text-decoration-none me-sm-5 me-3" rel="noreferrer"
                  >
                    <i className="fas fa-globe" />
                  </a>
                  <a
                    href="https://www.instagram.com/cargillgurme?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                    target="_blank"
                    className="text-white text-decoration-none" rel="noreferrer"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center border-top text-white fw-light small opacity-25 py-4">
          <div className="container">
            <p className="my-2">
              Copyright © 2024 Jarvis. Tüm Hakları Saklıdır.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default UserportalFooter;
